module.exports = __webpack_public_path__ + "static/img/homeChoiceBg.831d6b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/homeChoiceBg.png
// module id = NqDD
// module chunks = 3